// Per-company + per-period store for R&D and G&A spend cards in the
// Monthly Highlights section. Admin-editable until Sage is wired in.

const STORAGE_PREFIX = 'finkloz_spend_';
const CHANGE_EVENT = 'finkloz:spend-changed';

function key(companyId, period, type) {
  return `${STORAGE_PREFIX}${companyId || 'default'}_${period || 'default'}_${type}`;
}

const DEFAULTS = {
  rd: {
    label: 'R&D Spend',
    amount: 980000,
    items: [
      { label: 'Clinical trials', amount: 172000 },
      { label: 'Device manufacturing', amount: 168000 },
      { label: 'Testing & design', amount: 124000 },
      { label: 'Cleanroom & electrical', amount: 64000 },
    ],
    fyAvg: 468000,
    fyDeltaPct: 112,
    deltaIsBad: true, // red when positive
  },
  ga: {
    label: 'G&A Spend',
    amount: 175000,
    items: [
      { label: 'Software renewals', amount: 49000 },
      { label: 'Facilities & rent', amount: 47000 },
      { label: 'Patent & IP management', amount: 25000 },
      { label: 'Insurance & professional fees', amount: 22000 },
      { label: 'Other G&A', amount: 13000 },
    ],
    fyAvg: 198000,
    fyDeltaPct: -31,
    deltaIsBad: true, // red when positive, green when negative
  },
};

export function getSpendCard(companyId, period, type) {
  try {
    const raw = localStorage.getItem(key(companyId, period, type));
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed && typeof parsed === 'object') return { ...DEFAULTS[type], ...parsed };
    }
  } catch { /* ignore */ }
  return DEFAULTS[type];
}

export function saveSpendCard(companyId, period, type, card) {
  try {
    localStorage.setItem(key(companyId, period, type), JSON.stringify(card));
    window.dispatchEvent(new Event(CHANGE_EVENT));
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('saveSpendCard failed', e);
  }
}

export function subscribeToSpendChanges(callback) {
  const handler = () => callback();
  window.addEventListener(CHANGE_EVENT, handler);
  window.addEventListener('storage', handler);
  return () => {
    window.removeEventListener(CHANGE_EVENT, handler);
    window.removeEventListener('storage', handler);
  };
}

export function newItemId() {
  return 'si-' + Math.random().toString(36).slice(2, 9);
}
